import { Card, ListGroup, Badge } from 'react-bootstrap';

const ProjectStageSummary = ({ projects }) => {
  return (
    <Card>
      <Card.Header>Projects by Stage</Card.Header>
      <ListGroup variant="flush">
        {Object.entries(projects.by_stage).map(([stage, count]) => (
          <ListGroup.Item key={stage}>
            {stage} <Badge bg="secondary">{count}</Badge>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
};

export default ProjectStageSummary;
